<template>
  <div style="overflow: auto">
    <v-col cols="12">
      <div style="text-align: left">
        <b>Total Bonus:</b> ${{ total_bonus_designer }}
      </div>
    </v-col>
    <v-col cols="12">
      <v-row>
        <v-btn
          text
          small
          @click="
            role = 'crawl_new';
            loadRole();
          "
          v-if="role == 'crawl_new'"
          style="color: green"
          >Crawl New</v-btn
        >
        <v-btn
          text
          small
          @click="
            role = 'crawl_new';
            loadRole();
          "
          v-else
          >Crawl New</v-btn
        >
        <v-btn
          text
          small
          @click="
            role = 'crawl_reuse';
            loadRole();
          "
          v-if="role == 'crawl_reuse'"
          style="color: green"
          >Crawl Reuse</v-btn
        >
        <v-btn
          text
          small
          @click="
            role = 'crawl_reuse';
            loadRole();
          "
          v-else
          >Crawl Reuse</v-btn
        >
        <v-btn
          text
          small
          @click="
            role = 'upload_photo';
            loadRole();
          "
          v-if="role == 'upload_photo'"
          style="color: green"
          >Upload Photo</v-btn
        >
        <v-btn
          text
          small
          @click="
            role = 'upload_photo';
            loadRole();
          "
          v-else
          >Upload Photo</v-btn
        >
        <v-btn
          text
          small
          @click="
            role = 'normal_product_original';
            loadRole();
          "
          v-if="role == 'normal_product_original'"
          style="color: green"
          >Normal Product Original</v-btn
        >
        <v-btn
          text
          small
          @click="
            role = 'normal_product_original';
            loadRole();
          "
          v-else
          >Normal Product Original</v-btn
        >
        <v-btn
          text
          small
          @click="
            role = 'choose_options_original';
            loadRole();
          "
          v-if="role == 'choose_options_original'"
          style="color: green"
          >Choose Options Original</v-btn
        >
        <v-btn
          text
          small
          @click="
            role = 'choose_options_original';
            loadRole();
          "
          v-else
          >Choose Options Original</v-btn
        >
        <v-btn
          text
          small
          @click="
            role = 'choose_options_scale';
            loadRole();
          "
          v-if="role == 'choose_options_scale'"
          style="color: green"
          >Choose Options Scale</v-btn
        >
        <v-btn
          text
          small
          @click="
            role = 'choose_options_scale';
            loadRole();
          "
          v-else
          >Choose Options Scale</v-btn
        >
      </v-row>

      <table
        class="table table-bordered table-striped"
        v-if="listDataRole.length != 0 && !loading"
      >
        <thead class="thead-light">
          <tr>
            <th>STT</th>
            <th>Image</th>
            <th>Product Title</th>
            <th>Created Date</th>
            <th>Due Date</th>
            <th>Total Sales</th>
            <th>Profitable</th>
          </tr>
        </thead>
        <tbody style="text-align: left">
          <tr v-for="(value, text, index) in listDataRole" :key="index">
            <td>{{ index + 1 }}</td>
            <td>
              <img v-bind:src="value.product_thumbnail" style="width: 100px" />
            </td>
            <td>
              <div>{{ text }}</div>
              <div>{{ value.product_title }}</div>
            </td>
            <td>{{ value.product_created_date }}</td>
            <td>{{ value.product_due_date }}</td>
            <td>{{ value.total_sales }}</td>
            <td>
              <template v-if="value.is_profitable">Yes</template>
            </td>
          </tr>
        </tbody>
      </table>
      <div v-else-if="loading">
        <!-- <img v-bind:src="require('../assets/loading/'+link)"> -->
        <img v-bind:src="require('../../assets/loading/loading.gif')" />
      </div>
    </v-col>
  </div>
</template>

<script>
import Amplify, { Auth } from "aws-amplify";
import moment from "moment-timezone";
//import axios from "axios"

Amplify.configure({
  Auth: {
    region: "ap-southeast-1",
    userPoolId: "ap-southeast-1_8vBdk5PAd",
    userPoolWebClientId: "51e572vhkn38k7tuvsdst697b1",
    mandatorySignIn: true,
  },
});

export default {
  name: "KPIDesigner",
  props: {
    userId: String,
    listData: Object,
  },
  data: () => ({
    loading: false,
    listDataRole: [],
    menu2: false,
    report_month: new Date().toISOString().substr(0, 7),
    role: "",
    total_bonus_designer: "",
  }),
  created() {
    this.$root.$refs.KPIDesigner = this;
  },
  watch: {
    listData() {
      this.total_bonus_designer = this.listData.total_bonus;
    },
  },
  methods: {
    loadRole() {
      this.listDataRole = [];
      if (this.role == "crawl_new")
        this.listDataRole = JSON.parse(JSON.stringify(this.listData.crawl_new));
      else if (this.role == "crawl_reuse")
        this.listDataRole = JSON.parse(
          JSON.stringify(this.listData.crawl_reuse)
        );
      else if (this.role == "upload_photo")
        this.listDataRole = JSON.parse(
          JSON.stringify(this.listData.upload_photo)
        );
      else if (this.role == "normal_product_original")
        this.listDataRole = JSON.parse(
          JSON.stringify(this.listData.normal_product_original)
        );
      else if (this.role == "choose_options_original")
        this.listDataRole = JSON.parse(
          JSON.stringify(this.listData.choose_options_original)
        );
      else if (this.role == "choose_options_scale")
        this.listDataRole = JSON.parse(
          JSON.stringify(this.listData.choose_options_scale)
        );

      for (const item in this.listDataRole) {
        if (
          this.listDataRole[item].product_created_date != undefined &&
          this.listDataRole[item].product_due_date != undefined
        ) {
          this.listDataRole[item].product_created_date = moment(
            this.listDataRole[item].product_created_date
          )
            .tz("America/Los_Angeles")
            .format("DD/MMM/YYYY - HH:mm");
          this.listDataRole[item].product_due_date = moment(
            this.listDataRole[item].product_due_date
          )
            .tz("America/Los_Angeles")
            .format("DD/MMM/YYYY - HH:mm");
        }
      }
    },
    loadData() {
      this.listDataRole = [];
      this.role = "";
    },
  },
  async mounted() {
    try {
      await Auth.currentAuthenticatedUser({ bypassCache: false });
    } catch (error) {
      console.log("User logged out!");
      this.$router.push("/login");
    }
  },
};
</script>

<style scoped>
</style>